import { UsersList } from 'features/users/usersList';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLanguage } from '@/localization/useLanguage';
import { useAddParticipants } from '../viewmodel/useAddParticipants';
import SelectedUserChips from './SelectedUserChips';
import styles from './addParticipants.module.scss';

const AddParticipants = ({ onStateChange, groupData, existingGroupId, existingMemberIds = [], onClose }) => {
   const { t } = useLanguage();
   const isCreateMode = !existingGroupId;
   const { selectedUsers, isSubmitting, handleToggleUser, handleSubmit, isSubmitDisabled } = useAddParticipants({
      groupId: existingGroupId,
      groupName: groupData?.name,
      groupImage: groupData?.image,
      onClose,
   });

   useEffect(() => {
      if (onStateChange) {
         onStateChange({
            title: t('group.ADD_PARTICIPANTS'),
            rightIcons: [],
         });
      }
      return () => {
         if (onStateChange) onStateChange({});
      };
   }, [onStateChange, isCreateMode, t]);

   const getButtonLabel = () => {
      if (isSubmitting) return t('common.PROCESSING');
      if (isCreateMode) return t('group.CREATE_GROUP_BTN');
      return t('group.ADD_PARTICIPANTS');
   };

   return (
      <div className={`${styles.container} ${!isCreateMode ? styles.modalMode : ''} ct-flex ct-fcol ct-flex1`}>
         <div className={`${styles.listWrapper} ct-flex ct-fcol ct-flex1 `}>
            <UsersList
               config={{
                  selectable: true,
                  selectedUsers: selectedUsers,
                  onSelectionChange: handleToggleUser,
                  excludedUsers: existingMemberIds,
                  hideActions: true,
                  customHeader: <SelectedUserChips selectedUsers={selectedUsers} onRemove={handleToggleUser} />,
               }}
            />
         </div>
         <div className={`${styles.bottomBar} ct-flex ct-aiCenter ct-jcCenter`}>
            <button
               className={`${styles.createBtn} ${isSubmitDisabled ? styles.disabled : ''} ct-flexCenter ct-cursor`}
               onClick={handleSubmit}
               disabled={isSubmitDisabled}
            >
               {getButtonLabel()}
            </button>
         </div>
      </div>
   );
};

AddParticipants.propTypes = {
   onStateChange: PropTypes.func,
   groupData: PropTypes.object,
   existingGroupId: PropTypes.string,
   existingMemberIds: PropTypes.arrayOf(PropTypes.string),
   onClose: PropTypes.func,
};

export default AddParticipants;
